export enum UserType {
  Business,
  Dealer,
  Admin,
  Individual,
  User, // Added for backwards compatibility
}

export interface User {
  id: string; // Backend returns cuid (string)
  firstName: string;
  lastName: string;
  email: string;
  type: UserType;
  personalNumber?: string;
  phone?: string;
  // When false, the user must verify the email before accessing the app
  emailVerified?: boolean;
  // When false, the user must accept terms before accessing the app (after email verification)
  accountTermsAccepted?: boolean;
  // When false, the user must accept other terms (seller, auction, buyer, pricing) before ID verification
  otherTermsAccepted?: boolean;
}
